import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-solicitudes',
  templateUrl: './solicitudes.component.html',
  styleUrls: ['./solicitudes.component.scss']
})
export class SolicitudesComponent implements OnInit {

  lista: any;
  constructor(private prodSvc: ProductosService,
              private authSvc: AuthService) { }

  ngOnInit(): void {
    this.authSvc.cargarDistribuidoresPendientes()
                .subscribe(res => {
                  this.lista = res;
                });
  }

  aceptarDistribuidor(idUser: string){
    Swal.fire({
      title: 'Está seguro?',
      text: 'El usuario quedará activo como distribuidor!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, aceptar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.authSvc.aceptarDistribuidor(idUser);
        Swal.fire(
          'Activado!',
          'El usuario esta registrado como distribuidor.',
          'success'
        );
      }
    });
  }

  eliminarDistribuidor(idUser: string){
    Swal.fire({
      title: 'Está seguro?',
      text: 'Se eliminará esta solicitud',
      icon: 'question',
      showCancelButton: true,     
      confirmButtonText: 'Si, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.authSvc.eliminarDistribuidor(idUser);
        Swal.fire(
          'Eliminado!',
          'Solicitud borrada.',
          'success'
        );
      }
    });
  }

}
